import * as Sentry from '@sentry/nextjs';

export const logError = (error: Error | string, context?: Record<string, any>) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error(error);
    if (context) {
      // eslint-disable-next-line no-console
      console.error('Error context:', context);
    }
  } else {
    Sentry.captureException(error, { extra: context });
  }
};
